import request from '@/utils/request'

 // 查询供应商产能列表
  export function apiScpSopSupplierCapacity (query) {
    return request({
      url: `/scp/scpSopMpsSupplierCapacityLoad/list`,
      method: 'post',
      params: query
    })
  }
   // 修改供应商产能负荷-调整金额
   export function apiScpSopMpsSupplierCapacityLoad (query) {
    return request({
      url: `/scp/scpSopMpsSupplierCapacityLoad`,
      method: 'put',
      data: query
    })
  }
   // 计算供应商产能均衡（刷新）
   export function apiScpCalculateCapacityLoad (query) {
    return request({
      url: `/scp/scpMpsPlans/calculateCapacityLoad`,
      method: 'get',
      params: query
    })
  }

// 判断是否正在刷新产能负荷
export function apiCalculateCapacityLoadIs (query) {
  return request({
    url: `/scp/scpMpsPlans/calculateCapacityLoadIs`,
    method: 'get',
    params: query
  })
}

// 查询供应商产能负荷列表（工时版）
export function apiGetScpSopSupplierCapacityLoadManHours (query) {
  return request({
    url: `/scp/scpSopMpsSupplierCapacityLoadManHour/list`,
    method: 'post',
    params: query
  })
}
